// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManageSettingStep_wrapper_3MQvf","optionalMessage":"ManageSettingStep_optionalMessage_1sY9C"};